export const RECEIVING_WORKFLOW_RECEIVING_ASSISTANT = "receiving_assistant";
export const RECEIVING_WORKFLOW_ONSITE_CAPTURE = "onsite_capture";
export const RECEIVING_WORKFLOW_ONSITE_TO_WAREHOUSE = "onsite_capture_to_warehouse_storage";
export const RECEIVING_WORKFLOW_ONSITE_MANIFEST = "onsite_manifest";

export const RECEIVING_WORKFLOW_CARD_OPTIONS = [
  {
    value: RECEIVING_WORKFLOW_RECEIVING_ASSISTANT,
    label: "Warehouse Storage",
    description: "Choose this when items are received directly at the warehouse. This creates receiving reports, item labels, and warehouse storage tracking",
  },
  {
    value: RECEIVING_WORKFLOW_ONSITE_TO_WAREHOUSE,
    label: "Onsite Capture to Warehouse Storage",
    description: "Choose this when items are recorded onsite before they arrive at the warehouse. Teams capture photos, details, and quantities onsite, then the warehouse confirms quantities and assigns storage locations",
  },
  {
    value: RECEIVING_WORKFLOW_ONSITE_CAPTURE,
    label: "Onsite Capture",
    description: "Choose this when items only need to be recorded onsite. This tracks captured items without warehouse receiving reports or storage locations",
  },
  {
    value: RECEIVING_WORKFLOW_ONSITE_MANIFEST,
    label: "Onsite Manifest",
    description: "Import a manifest of expected inventory as SKUs, validate items onsite, and transfer to warehouse storage",
  },
];

/** Options for Select: [value, label] */
export const RECEIVING_WORKFLOW_OPTIONS = RECEIVING_WORKFLOW_CARD_OPTIONS.map(({ value, label }) => [value, label]);

export function workflowRequiresMovewareStorageAccount(workflow) {
  return workflow !== RECEIVING_WORKFLOW_ONSITE_CAPTURE;
}

export function receivingWorkflowToMutationVariables(workflow) {
  switch (workflow) {
    case RECEIVING_WORKFLOW_ONSITE_CAPTURE:
      return { storageEnabled: false, onsiteCaptureToWarehouseStorage: false };
    case RECEIVING_WORKFLOW_ONSITE_TO_WAREHOUSE:
      return { storageEnabled: true, onsiteCaptureToWarehouseStorage: true };
    case RECEIVING_WORKFLOW_ONSITE_MANIFEST:
      return { storageEnabled: false, onsiteCaptureToWarehouseStorage: false };
    case RECEIVING_WORKFLOW_RECEIVING_ASSISTANT:
    default:
      return { storageEnabled: true, onsiteCaptureToWarehouseStorage: false };
  }
}

/**
 * Apply a workflow selection to Formik fields in the Customer Toggles modal.
 * Unlike receivingWorkflowToMutationVariables (used for GraphQL), this maps
 * to the Formik field paths used in the toggles form.
 */
export function applyWorkflowToFormik(workflow, setFieldValue) {
  const isWarehouse = workflow === RECEIVING_WORKFLOW_RECEIVING_ASSISTANT;
  const isOnsiteToWarehouse = workflow === RECEIVING_WORKFLOW_ONSITE_TO_WAREHOUSE;
  const isOnsiteManifest = workflow === RECEIVING_WORKFLOW_ONSITE_MANIFEST;

  setFieldValue("storageEnabled", isWarehouse || isOnsiteToWarehouse);
  setFieldValue("settings.onsite_capture_to_warehouse_storage", isOnsiteToWarehouse);
  setFieldValue("settings.onsite_manifest", isOnsiteManifest);
  if (workflow !== RECEIVING_WORKFLOW_ONSITE_CAPTURE) {
    setFieldValue("settings.onsite_inventory_capture", false);
  }
}

/** Determine the current workflow from Formik values. */
export function getWorkflowFromValues(values) {
  if (values.settings?.onsite_manifest) return RECEIVING_WORKFLOW_ONSITE_MANIFEST;
  if (values.settings?.onsite_capture_to_warehouse_storage) return RECEIVING_WORKFLOW_ONSITE_TO_WAREHOUSE;
  if (values.storageEnabled) return RECEIVING_WORKFLOW_RECEIVING_ASSISTANT;
  return RECEIVING_WORKFLOW_ONSITE_CAPTURE;
}

export function isOnsiteCaptureProject(project) {
  if (!project?.id) return false;

  return (
    getWorkflowFromValues({
      storageEnabled: project.storageEnabled,
      settings: project.settings || {},
    }) === RECEIVING_WORKFLOW_ONSITE_CAPTURE
  );
}
